import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import InViewMonitor from 'react-inview-monitor'

import Button from './Button'
import PageHeader from './PageHeader'
import EnterpriseContactModal from './EnterpriseContactModal'
import Video from './Video'
import Link from '../components/Link'
import TopBanner from '../components/TopBanner'

import { showModal } from '../../reducers/modal'

import { trackEvent } from '../../utils/tracking'

import { MAKERS_URL } from '../../config'

const PICNIC_FULL_VIDEO = 'static/videos/picnic.mp4'
const PICNIC_LOOP_VIDEO = 'static/videos/picnic-loop.mp4'

class HomePageHeroSection extends Component {
  constructor () {
    super()
    this.state = {
      showPicnicLoopVideo: false
    }
  }
  render () {
    const {
      titleFirstLine,
      titleSecondLine,
      // content,
      // subtitle,
      // ctaButtonLabel,
      demoButtonLabel,
      ctaButtonSubtitle,
      demoButtonSubtitle,
      showModal
    } = this.props

    const { showPicnicLoopVideo } = this.state

    // TODO : move hardocoded to wordpress
    const content = `
      Snips is a Private-by-Design, Decentralized, Open Source Voice Assistant.
    `
    const ctaButtonLabel = `
      Start building with Snips
    `

    return (
      <div className='homepage-hero-section bg-white maxw-xxlarge mx-auto'>
        {// Removed because we added an airstream section on the main page, and an ICO banner.
        false && (
          <TopBanner
            content={
              <div className='top-banner__inner maxw-xxlarge mx-auto bg-black white bold px2'>
                <p className='py3'>
                  Introducing the Voices of Privacy Airstream -{' '}
                  <Link
                    className='top-banner__airstream-link white'
                    href='/airstream'
                    target='_blank'
                  >
                    Join us!
                  </Link>
                </p>
              </div>
            }
          />
        )}
        {/* NOTE: Helmet content gets extracted and injected into <head> tag, dynamically */}
        <Helmet>
          {/* so that when we switch to the loop video, it’s already loaded */}
          <link
            rel='preload'
            href={PICNIC_LOOP_VIDEO}
            as='video'
            type='video/mp4'
          />
        </Helmet>
        <PageHeader title={null}>
          <div className='homepage-hero-section__body'>
            <h1 className='homepage-hero-section__body__title strong mb2'>
              <div className='homepage-hero-section__body__title--big blue'>
                {titleFirstLine}
              </div>
              {titleSecondLine && (
                <span className='homepage-hero-section__body__title--small mr1'>
                  {titleSecondLine}
                </span>
              )}
            </h1>
            <div
              className='homepage-hero-section__body__subtitle text-para small mb3'
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
          <div className='homepage-hero-section__body__image mb3 relative'>
            {/*
              2 separate videos are used here:
              - at the top layer we have a loop video, only shown _after the other video has finished.
              - at the bottom we have the first video, which does not loop.
              We use two layered videos to transition between them without any flash of nothing,
              as we otherwise get if we just swap the source.
              */}
            <div
              className='absolute top-0 left-0 right-0 bottom-0'
              style={{
                zIndex: '1',
                opacity: showPicnicLoopVideo ? undefined : '0'
              }}
            >
              {/* We pause this video when it scrolls out of view */}
              {showPicnicLoopVideo && (
                <InViewMonitor
                  childPropsInView={{ isPlaying: true }}
                  toggleChildPropsOnInView
                  intoViewMargin='-10%'
                >
                  <Video controls={false} src={PICNIC_LOOP_VIDEO} />
                </InViewMonitor>
              )}
            </div>
            <Video
              src={PICNIC_FULL_VIDEO}
              isAutoPlaying
              controls={false}
              loop={false}
              onVideoEnded={() => this.setState({ showPicnicLoopVideo: true })}
            />
          </div>
          <div className='homepage-hero-section__actions mb2'>
            <a
              className='homepage-hero-section__actions__button button button--primary mb2'
              href={MAKERS_URL}
              onClick={e =>
                trackEvent('MakersLink', { context: 'HomePageHero' })}
            >
              {/* Extra wrapping div needed for flex alignment */}
              <div>
                <div>{ctaButtonLabel}</div>
                {ctaButtonSubtitle && (
                  <div className='homepage-hero-section__actions__button--subtitle'>
                    {ctaButtonSubtitle}
                  </div>
                )}
              </div>
            </a>
            {demoButtonLabel && (
              <Button
                className='homepage-hero-section__actions__button button button--secondary full-width mb2'
                onClick={() => {
                  trackEvent('EnterpriseContactModal', 'HomePageHeroSection')
                  showModal(<EnterpriseContactModal />)
                }}
              >
                {/* Extra wrapping div needed for flex alignment */}
                <div>
                  <div>{demoButtonLabel}</div>
                  {demoButtonSubtitle && (
                    <div className='homepage-hero-section__actions__button--subtitle'>
                      {demoButtonSubtitle}
                    </div>
                  )}
                </div>
              </Button>
            )}
          </div>
        </PageHeader>
      </div>
    )
  }
}

HomePageHeroSection.propTypes = {
  titleFirstLine: PropTypes.string.isRequired,
  titleSecondLine: PropTypes.string,
  content: PropTypes.node.isRequired,
  ctaButtonLabel: PropTypes.string,
  demoButtonLabel: PropTypes.string,
  ctaButtonSubtitle: PropTypes.string,
  demoButtonSubtitle: PropTypes.string
}

export default connect(null, { showModal })(HomePageHeroSection)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/HomePageHeroSection.js